import { createSelector } from "@ngrx/store";
import { SelectSupplierModuleState } from "../suppliermodule.selector";


export const GetTaxIDTypes = createSelector(
    SelectSupplierModuleState,
    state => state.TaxState.taxIdTypes
);

export const GetTaxCountries = createSelector(
    SelectSupplierModuleState,
    state => state.TaxState.taxCountries
);